import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-incentive-marks',
  templateUrl: './incentive-marks.component.html',
  styleUrls: ['./incentive-marks.component.scss']
})
export class IncentiveMarksComponent implements OnInit {
  IncMrkForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  listdesc: any;
  clgname: any;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.IncMrkForm = this.fb.group({
      IncMrklistNo: new FormControl(),
      IncMrklistNo2: new FormControl(),
      IncMrklistNo3: new FormControl('New'),
      IncMrkClg: new FormControl(),
      IncMrkValid: new FormControl(),
      IncMrkChng: new FormControl(),
      IncMrkBatch: new FormControl(),
      IncMrkSrNo: new FormControl(),
      IncMrkRollNo: new FormControl(),
      IncMrkCode: new FormControl(),
      IncMrkMarks: new FormControl(),
      IncMrkValid2: new FormControl(),
      IncMrkValid3: new FormControl(),
     } );

    
  }

  deletee(e, k){
    if (e === 'true'){
      this.prepopulationForDelete(k);
    } else {
      
    }
  }

  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
  }
 
  getExmFrmList(id){
    const payload = {};
    payload['InCode'] = id;
    payload['SnNo'] = this.umsService.secretdata['SnNo'];
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
       
      } else {
      }
    });
  }

  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }


  prepopulation(data){
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    
  }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
       this.IncMrkForm.reset();
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }


  submit(){
    if (this.IncMrkForm.invalid) {
      
      return;
    } else {
      this.submitEnrollment();
    }
  }
  submitEnrollment() {
    this.submitpayload = this.IncMrkForm.value;
  }

  delete(){

  }

  update(){
    if (this.IncMrkForm.invalid) {
      return;
    } else {
      this.updateEnrollment();
    }
  }

  updateEnrollment(){

  }

}
